import useSWRMutation from 'swr/mutation';
import fetcher from 'lib/fetcher';
import { toast } from 'react-toastify';

const useDeleteFavoriteListFacilityItem = (
  favoriteId: number,
  facilityId: number,
  isReject?: boolean,
) => {
  async function fetchDeleteFavoriteListFacilityItem(url: string) {
    const messageError = isReject
      ? 'Не удалось отклонить объект из списка'
      : 'Не удалось удалить объект из списка';

    const messageSuccess = isReject ? 'Объект отклонен' : 'Объект удален из списка';

    try {
      const data = await fetcher.delete(url);
      if (data?.error) {
        return toast.error(`${messageError}, ${data?.error}`, {
          autoClose: 5000,
        });
      }
      toast.success(messageSuccess, { autoClose: 5000 });
      return data.result;
    } catch (error) {
      throw toast.error(messageError, { autoClose: 5000 });
    }
  }

  const { data, error, isMutating, ...rest } = useSWRMutation(
    isReject
      ? `/favourites/list/reject/${favoriteId}/${facilityId}`
      : `/favourites/list/${favoriteId}/${facilityId}`,
    fetchDeleteFavoriteListFacilityItem,
  );

  return { data, error, isMutating, ...rest };
};
export default useDeleteFavoriteListFacilityItem;
